angular
	.module('vppApp')
	.service('CustomerService', CustomerService);

CustomerService.$inject = ['$http', '$rootScope', 'apiFactory', 'AuthenticationService', '$state', 'ProgramStopGateService', 'TimeOutService', 'VarientService'];

function CustomerService($http, $rootScope, apiFactory, AuthenticationService, $state, ProgramStopGateService, TimeOutService, VarientService) {
	var observers = [];

	var CustomerService = {};
	var isAuthed = false;
	$rootScope.customerData = {};
	var accountId = AuthenticationService.getAuthenticatedID();
	var varient;

	var _setVarientsByProgramCode = function (programCodes) {
		var sotyProgramCodes = [
			'soty',
			'soty19',
			'soty20',
			'soty21',
			'soty22',
			'soty23',
			'soty25',
			'soty25ev'
		];
		var programCodesLength = programCodes.length;

		// loop through SOTY program codes, set SOTY varient if there is a match
		for (var i = 0; i < programCodesLength; i++) {
			var programCode = programCodes[i].code.toLowerCase();

			if (sotyProgramCodes.indexOf(programCode) > -1) {
				// varient = 'soty';
				// VarientService.addVarient(varient);

				break;
			}
		}
	};

	CustomerService.loadedCallback = function (callback) {
		if (accountId === "") accountId = AuthenticationService.getAuthenticatedID();
		apiFactory.getCustomer(accountId).then(function (response) {
			(function () {
				AuthenticationService.setUserDetail(response, response.data.customerDetails.emailAddress);
				var data = response.data;
				//console.log("getCust ~ " + response.data.auditRequired);
				// check for Audit Flag
				if (response.data.auditRequired === true) {
					$rootScope.accountAudit = true;
					$state.go('account-audit');
				}

				// create userObj from success
				ProgramStopGateService.generateWhitelistedProgramDetailsList(data.programDetails).then(function (whitelistedPrograms) {

					_setVarientsByProgramCode(whitelistedPrograms);

					// create userObj from success
					$rootScope.customerData = {
						customer: {
							programIDs: whitelistedPrograms,
							firstName: data.customerDetails.firstName,
							lastName: data.customerDetails.lastName,
							address1: data.customerDetails.addressLine1,
							address2: data.customerDetails.addressLine2,
							city: data.customerDetails.city,
							state: data.customerDetails.state,
							zipCode: data.customerDetails.zipCode,
							country: data.customerDetails.country,
							phone: data.customerDetails.phoneNumber,
							cellPhone: data.customerDetails.cellPhone,
							email: data.customerDetails.email,
							companyCode: data.companyCode,
							companyName: data.companyName
						}
					};

					// sets localStorage data
					window.localStorage['vppDataCustomer'] = angular.toJson($rootScope.customerData);
					// sets sessionStorage data
					window.sessionStorage.setItem("vppDataCustomer", angular.toJson($rootScope.customerData));

					if (callback !== undefined && typeof callback === 'function') {
						callback();
					}

				}, function (response) {
					// if fails, set programIDs to empty array
					$rootScope.customerData = {
						customer: {
							programIDs: [],
							firstName: data.customerDetails.firstName,
							lastName: data.customerDetails.lastName,
							address1: data.customerDetails.addressLine1,
							address2: data.customerDetails.addressLine2,
							city: data.customerDetails.city,
							state: data.customerDetails.state,
							zipCode: data.customerDetails.zipCode,
							country: data.customerDetails.country,
							phone: data.customerDetails.phoneNumber,
							cellPhone: data.customerDetails.cellPhone,
							email: data.customerDetails.email,
							companyCode: data.companyCode,
							companyName: data.companyName
						}
					};

					// sets localStorage data
					window.localStorage['vppDataCustomer'] = angular.toJson($rootScope.customerData);
					// sets sessionStorage data
					window.sessionStorage.setItem("vppDataCustomer", angular.toJson($rootScope.customerData));

					if (callback != undefined && typeof callback == 'function') {
						callback();
					}

				});

			})(callback);

		}, function errorCallback(response) {
			console.log('cust error', response.data.errors);
			TimeOutService.checkAuthError(response);
			this.destroyCustomer();
			$scope.serverError = response.data.errors;
			// called asynchronously if an error occurs
			// or server returns response with an error status.
		});
	}

	var _createCustomerObj = function (customer) {

		ProgramStopGateService.generateWhitelistedProgramDetailsList(customer.programDetails).then(function (whitelistedPrograms) {

			_setVarientsByProgramCode(whitelistedPrograms);

			$rootScope.customerData = {
				customer: {
					programIDs: customer.programDetails,
					firstName: customer.customerDetails.firstName,
					lastName: customer.customerDetails.lastName,
					address1: customer.customerDetails.addressLine1,
					address2: customer.customerDetails.addressLine2,
					city: customer.customerDetails.city,
					state: customer.customerDetails.state,
					zipCode: customer.customerDetails.zipCode,
					country: customer.customerDetails.country,
					phone: customer.customerDetails.phoneNumber,
					cellPhone: customer.customerDetails.cellPhone,
					email: customer.customerDetails.email,
					companyCode: customer.companyCode,
					companyName: customer.companyName

				}
			};
		}, function (response) {
			// if fails, set programIDs to empty array
			$rootScope.customerData = {
				customer: {
					programIDs: [],
					firstName: customer.customerDetails.firstName,
					lastName: customer.customerDetails.lastName,
					address1: customer.customerDetails.addressLine1,
					address2: customer.customerDetails.addressLine2,
					city: customer.customerDetails.city,
					state: customer.customerDetails.state,
					zipCode: customer.customerDetails.zipCode,
					country: customer.customerDetails.country,
					phone: customer.customerDetails.phoneNumber,
					cellPhone: customer.customerDetails.cellPhone,
					email: customer.customerDetails.email,
					companyCode: customer.companyCode,
					companyName: customer.companyName
				}
			};
		});
	};

	CustomerService.addObserver = function (callback) {
		observers.push(callback);
		if ($rootScope.customerData && $rootScope.customerData.customer) {
			callback($rootScope.customerData.customer);
		}
	};

	CustomerService.removeObserver = function (callback) {
		var index = observers.indexOf(callback);
		if (index > -1) { observers.splice(index, 1); }
	};

	function notifyObservers() {
		angular.forEach(observers, function (callback) {
			if ($rootScope.customerData && $rootScope.customerData.customer) {
				callback($rootScope.customerData.customer);
			} else {
				callback(null);
			}
		});
	}

	CustomerService.setCustomer = function (customerData) {
		// create userObj from success
		_createCustomerObj(customerData.data);
		// sets localStorage data
		window.localStorage['vppDataCustomer'] = angular.toJson($rootScope.customerData);
		// sets sessionStorage data
		window.sessionStorage.setItem("vppDataCustomer", angular.toJson($rootScope.customerData));
		notifyObservers();
	};

	CustomerService.destroyCustomer = function () {
		window.localStorage.removeItem("vppDataCustomer");
		window.sessionStorage.removeItem('vppDataCustomer');
		$rootScope.customerData = {};
		isAuthed = false;
		notifyObservers();
	};

	CustomerService.getProgramIDs = function () {
		var _programIDs = $rootScope.customerData.customer.programIDs;
		return _programIDs;
	};

	CustomerService.getUserFirstName = function () {
		var _firstName = $rootScope.customerData.customer.firstName;
		return _firstName;
	};

	CustomerService.getClientCode = function () {
		var _partnerClientCode = $rootScope.customerData.customer.partnerClientCode;
		return _partnerClientCode;
	};
	CustomerService.getUserEmail = function () {
		var _userEmail = $rootScope.customerData.customer.email;
		return _userEmail;
	};

	CustomerService.getCustomerData = function () {
		var _customerData = $rootScope.customerData;
		return _customerData;
	};

	CustomerService.fetchCustomer = function (accountId) {
		apiFactory.getCustomer(accountId).then(function successCustomerGet(response) {
			var data = response.data;
			if (response.data.auditRequired === true) {
				$rootScope.accountAudit = true;
				$state.go('account-audit');
			}
			CustomerService.setCustomer(response);
		}, function errorCallback(response) {
			console.log('cust error', response.data.errors);
			CustomerService.destroyCustomer();
			$rootScope.serverError = response.data.errors;
		});
	};

	if (accountId) {
		CustomerService.fetchCustomer(accountId);
	}

	return CustomerService;

};
